import axios from 'axios'
export default {
    /**
     * Создает новый адрес доставки
     * @param id
     * @param params
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async edit(id, params, success, failure) {
        await axios.post('/api/delivery-address/save/' + id, params)
            .then(res => success(res.data))
            .catch(err => failure(err));
    },

    /**
     * Получает список адресов пользователя
     * @param id
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadForCurrentUser(success) {
        await axios.get('/api/delivery-address/list/')
            .then(res => success(res.data))
            .catch(err => console.log(err));
    },

    /**
     * Получает список адресов пользователя
     * @param id
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async delete(id, success) {
        await axios.post('/api/delivery-address/delete/' + id)
            .then(res => success(res.data))
            .catch(err => console.log(err));
    },

    /**
     * Получает список адресов пользователя
     * @param id
     * @param success
     * @param failure
     * @returns {Promise<void>}
     */
    async loadSingle(id, success) {
        await axios.get('/api/delivery-address/' + id)
            .then(res => success(res.data))
            .catch(err => console.log(err));
    },
}